import { WOW } from 'wowjs';
import "animate.css";
import { useHomeStore } from "../../../store/home"; //引入home仓库

import { storeToRefs } from 'pinia'; //引入方法让仓库里的值可以解构赋值并且具有响应式

import { onMounted, nextTick } from "vue";
import { useRouter } from 'vue-router';
export default {
  name: "ProductCenter",
  setup: function setup() {
    var store = useHomeStore();
    var router = useRouter();
    onMounted(function () {
      //初始化wow.js(页面滚动加载动画)
      nextTick(function () {
        //页面渲染完，在执行
        var wow = new WOW({
          live: false
        });
        wow.init();
      }); //通知vuex发送请求获取产品中心的数据

      store.getProductShow();
    }); //数据

    var _storeToRefs = storeToRefs(store),
        productShow = _storeToRefs.productShow; //从仓库获取数据
    //事件


    function goProduct() {
      //跳转到产品中心页面
      router.push('/product');
    }

    return {
      productShow: productShow,
      goProduct: goProduct
    };
  }
};